<!-- <div class="messages-container" *ngIf="massages && massages.length"> -->
<div class="messages-container">
  <p *ngFor="let notificationMessage of massages" [ngClass]="getClassName(notificationMessage)"
    class="notification-massage container">
    <fa-icon [icon]="getIcon(notificationMessage)"></fa-icon>
    <span>{{ notificationMessage.message | odooErrorMessage | translate }}</span>
  </p>
</div>
